module.exports = __webpack_public_path__ + "img/fuli.50678d39.png";